module.exports = __webpack_public_path__ + "img/imagen-tarjeta.33e85d59.png";